import React from "react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router";
import ErrorBoundary from "./ErrorBoundary";
// context management
import { AuthProvider } from "./contexts/AuthContext";
import { AccordionProvider } from "./contexts/AccordionContext";
import { AlertProvider } from "./contexts/AlertContext";

import { createRoot } from "react-dom/client";
// css files to remove
import "./custom.css";
// npm package imports => dont forget to update with npm run copy-css + update final_report.js
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "material-symbols/index.css";
import "jquery/dist/jquery.slim.min.js";
import "@popperjs/core/dist/umd/popper.min.js";
// chart.js
import Chart from "chart.js/auto";
import annotationPlugin from "chartjs-plugin-annotation";
import dataLabels from "chartjs-plugin-datalabels";

Chart.register(dataLabels);
Chart.register(annotationPlugin);

//add to the global window object
window.Chart = Chart;
window.ChartDataLabels = dataLabels;
window.ChartAnnotation = annotationPlugin;

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <AlertProvider>
          <AccordionProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </AccordionProvider>
        </AlertProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
